import BaseOnboardingService from "./baseOnboarding.service";

class UnavailabilityMainCauseService extends BaseOnboardingService {
  constructor() {
    super("unavailability-mainCause");
  }
}

export default new UnavailabilityMainCauseService();